import { useFilterParams } from '~/hooks/filters/useFilterParams';
import { useHasAnyClipFilterApplied } from '~/hooks/filters/useHasAnyClipFilterApplied';
import { useIsFlattenedView } from '~/hooks/search/useIsFlattenedView';

export function useCanShowFiles() {
  const { typesParam } = useFilterParams();

  return {
    canShowFiles: typesParam.length === 0 || typesParam.includes('files'),
  };
}

export function useCanShowAssets() {
  const { typesParam } = useFilterParams();

  return { canShowAssets: typesParam.length === 0 || typesParam.includes('assets') };
}

export type UseCanShowBoardsOptions = {
  /**
   * When true, the hook treats `isFlattenedView` as `false` regardless of URL state.
   * Public callers set this from `lockedControls.expandNested` so a stale `?flat=true`
   * URL can't hide boards on a locked share.
   */
  isExpandNestedDisabled?: boolean;
};

export const useCanShowBoards = ({ isExpandNestedDisabled = false }: UseCanShowBoardsOptions = {}) => {
  const { typesParam } = useFilterParams();
  const { isFlattenedView } = useIsFlattenedView({ disabled: isExpandNestedDisabled });
  const { hasAnyClipFilterApplied } = useHasAnyClipFilterApplied();

  /**
   * Any time a user applies a filter (besides the type filter), we hide boards.
   * For example, if a user chooses the uploader filter and selects to filter assets
   * by a user in the workspace who uploaded those assets, we don't show boards.
   */
  const canShowBoards =
    (typesParam.length === 0 || typesParam.includes('boards')) && !hasAnyClipFilterApplied && !isFlattenedView;

  // non-board pages should show boards only when search params are present
  return {
    canShowBoards,
  };
};
